import "./Fine.css";

import Agreement from "../../components/Fine/Agreement/Agreement";
import FineDetails from "../../components/Fine/FineDetails/FineDetails";
import FineHeader from "../../components/Fine/FineHeader/FineHeader";
import { FineType } from "../../models/fineModels";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Payment from "../../components/Fine/Payment/Payment";
import { useAppSelector } from "../../hooks/reduxHooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Fine = () => {
  let navigate = useNavigate();
  const fineType = useAppSelector((state) => state.fine.type);
  const currentStep = useAppSelector((state) => state.fine.currentStep);
  const infringement = useAppSelector((state) => state.fine.infringement);
  const user = useAppSelector((state) => state.auth.user);
  // const handbackStatus = useAppSelector(
  //   (state) => state.handback.handbackStatus
  // );

  useEffect(() => {
    if (fineType === FineType.WARRANT && !user) navigate("/warrant");
    // if (handbackStatus) navigate("/");
    if (!infringement) {
      navigate("/");
    }
  }, []);

  const renderSteps = () => {
    if (fineType === FineType.NONWARRANT) {
      switch (currentStep) {
        case 1:
          return <FineDetails />;
        case 2:
          return <Payment />;
        default:
          break;
      }
    } else {
      switch (currentStep) {
        case 1:
          return <FineDetails />;
        case 2:
          return <Agreement />;
        case 3:
          return <Payment />;
        default:
          break;
      }
    }
  };
  return (
    <div className="fine-container">
      <Header title="City of Cape Town - Traffic Fines" />
      <div className="fine-content">
        <FineHeader navigate={navigate} />
        {renderSteps()}
      </div>
      <Footer />
    </div>
  );
};

export default Fine;
